import formatters from '@/filters/customFormatters'
import campaignsUtils from '@/mixins/campaignsUtils'
import campaignsService from '@/api/campaignsService'
import Portal from '@/directives/portal'
import {
  CAMPAIGN_STATUSES,
  CAMPAIGN_TYPES,
  // CHANNEL_OPTIONS_EXTERIOR,
  CAMPAIGN_COMMENTS_LABELS
} from '@/utils/campaignOptions'
import authService, { USER_ROLES } from '@/api/authService'
// import channelService from '@/api/channelService'
import moment from 'moment'
import i18n from '@/i18n'

export default {
  name: 'CampaignActivation',
  mixins: [formatters, campaignsUtils],
  components: {
    ActivationInfo: () =>
      import('@/components/campaign-activation/activation-info/ActivationInfo.vue'),
    ActivationChannels: () =>
      import('@/components/campaign-activation/activation-channels/ActivationChannels.vue'),
    ActivationCkeckDirector: () =>
      import('@/components/campaign-activation/activation-check/activation-ckeck-director/ActivationCkeckDirector.vue'),
    ActivationCheckHead: () =>
      import('@/components/campaign-activation/activation-check/activation-check-head/ActivationCheckHead.vue'),
    ActivationCheckExterior: () =>
      import('@/components/campaign-activation/activation-check/activation-check-exterior/ActivationCheckExterior.vue'),
    ActivationSettingsDirector: () =>
      import('@/components/campaign-activation/activation-settings/activation-settings-director/ActivationSettingsDirector.vue'),
    ActivationSettingsHead: () =>
      import('@/components/campaign-activation/activation-settings/activation-settings-head/ActivationSettingsHead.vue'),
    ActivationSettingsExterior: () =>
      import('@/components/campaign-activation/activation-settings/activation-settings-exterior/ActivationSettingsExterior.vue'),
    CampaignComments: () =>
      import('@/components/campaign-comments/CampaignComments.vue')
  },
  props: {},
  data () {
    return {
      authData: authService.authData,
      selectedTab: 'info',
      campaign: undefined,
      isDeleting: false,
      tabOrder: ['info', 'channels', 'check', 'activation'],
      comments: [],
      lastCentralCommentStatus: undefined,
      lastDirectorCommentStatus: undefined,
      loading: false
    }
  },
  mounted () {
    if (this.campaignId) {
      this.getCampaign(this.campaignId)
    }
    const selectedTabFromQuery = this.$route.query && this.$route.query.tab
    if (selectedTabFromQuery) {
      this.selectedTab = this.tabOrder[selectedTabFromQuery - 1]
    }
  },
  computed: {
    isExterior () {
      return this.campaign && this.campaign.type === CAMPAIGN_TYPES.EXTERIOR
    },
    tab3Name () {
      if (this.isAgencyExterior && this.isExterior) return i18n.t('CREATIVITIES')
      return this.isExterior ? `3. ${i18n.t('CREATIVITIES')}` : `3. ${i18n.t('CHECK')}`
    },
    newCampaignLabel () {
      return this.type === CAMPAIGN_TYPES.EXTERIOR
        ? i18n.t('NEW_EXTERIOR_CAMPAIGN')
        : i18n.t('NEW_DIGITAL_CAMPAIGN')
    },
    type () {
      return this.$route.query.type
    },
    readonly () {
      const statuses = [
        CAMPAIGN_STATUSES.DRAFT,
        CAMPAIGN_STATUSES.CENTRAL_READY
      ]
      return this.campaign && statuses.indexOf(this.campaign.status) === -1
    },
    campaignId () {
      return this.$route.params.campaignid
    },
    isNew () {
      return this.campaignId && this.campaignId === 'new'
    },
    isDirector () {
      return this.authData.user.role === USER_ROLES.DIRECTOR
    },
    isCentral () {
      return (
        this.authData.user.role === USER_ROLES.CENTRAL ||
        this.authData.user.role === USER_ROLES.CENTRAL_ADMIN
      )
    },
    isAgency () {
      return this.authData.user.role === USER_ROLES.AGENCY
    },
    isAgencyExterior () {
      return this.authData.user.role === USER_ROLES.AGENCY_EXTERIOR
    },
    isAdmin () {
      return this.authData.user.role === USER_ROLES.ROOT
    },
    campaignReviewed () {
      return (
        this.campaign &&
        this.campaign.status !== CAMPAIGN_STATUSES.DRAFT &&
        this.campaign.status !== CAMPAIGN_STATUSES.CENTRAL_READY
      )
    },
    startDateValid () {
      const dateDiif = this.isAdmin ? 0 : 4
      return (
        this.campaign &&
        (this.campaign.status !== CAMPAIGN_STATUSES.DRAFT ||
          moment(this.campaign.start_date).diff(
            moment().startOf('day'),
            'days'
          ) > dateDiif)
      )
    },
    canShowDelete () {
      return (
        !this.isNew &&
        this.campaign &&
        (this.campaign.status === CAMPAIGN_STATUSES.DRAFT ||
          this.campaign.status === CAMPAIGN_STATUSES.CENTRAL_REJECTED ||
          this.campaign.status === CAMPAIGN_STATUSES.CENTRAL_READY)
      )
    }
  },
  methods: {
    closeModal () {
      this.$emit('edit', this.campaign)
      this.$router.push('/campaigns')
    },
    closeExterior () {
      this.$emit('delete', this.campaign.id)
      this.$router.push('/campaigns')
    },
    async deleteCampaign () {
      if (!this.isDeleting) {
        this.isDeleting = true
        return
      }

      await campaignsService.deleteCampaign({ id: this.campaign.id })
      this.$emit('delete', this.campaign.id)
      this.$router.push('/campaigns')
    },
    selectTab (tab) {
      this.selectedTab = tab.id
    },
    isCompleted (tab) {
      const {
        DRAFT,
        AGENCY_PROVISIONING,
        CENTRAL_ACCEPTED, // CENTRAL_REJECTED,
        AGENCY_CONFIRMED,
        ACTIVE,
        FINISHED
      } = CAMPAIGN_STATUSES
      const noData = this.readonly && !this.campaign.channels.length
      if (tab !== 'info' && noData) {
        return false
      }
      switch (tab) {
        case 'info':
          return this.startDateValid && this.campaign.id !== undefined
        case 'channels':
          return this.campaign && this.campaign.status !== DRAFT
        case 'check':
          if (this.isExterior) {
            return (
              this.campaign.status !== AGENCY_PROVISIONING &&
              this.campaign.status !== DRAFT
            )
          }
          return (
            this.campaign &&
            [CENTRAL_ACCEPTED, AGENCY_CONFIRMED, ACTIVE, FINISHED].indexOf(
              this.campaign.status
            ) !== -1
          )
        case 'activation':
          return (
            this.campaign &&
            [AGENCY_CONFIRMED, ACTIVE, FINISHED].indexOf(
              this.campaign.status
            ) !== -1
          )
        default:
          return false
      }
    },
    isSelected (tab) {
      return this.selectedTab === tab
    },
    next (campaign, action) {
      if (campaign) {
        this.campaign = campaign
        this.$router.push(`/campaigns/${campaign.id}`)
        this.$emit(action, campaign)
      }
      const index = this.tabOrder.indexOf(this.selectedTab)
      const nextTab = this.tabOrder[index + 1]
      this.selectedTab = nextTab
    },
    back () {
      const index = this.tabOrder.indexOf(this.selectedTab)
      const prevTab = this.tabOrder[index - 1]
      this.selectedTab = prevTab
    },
    async getCampaign (id) {
      this.loading = true
      const campaign = await campaignsService.getCampaign({ id })

      if (campaign.metadata && campaign.metadata.exterior_director_data) {
        // Get last comment status from director
        const lastComment = campaign.metadata.exterior_director_data.slice(
          -1
        )
        this.lastDirectorCommentStatus = lastComment ? lastComment[0].status : undefined

        campaign.metadata.exterior_director_data.forEach(comment => {
          this.comments.push({
            status: comment.status,
            comment: comment.comment,
            date: new Date(new Date(comment.date).toISOString()),
            user: comment.user,
            title: CAMPAIGN_COMMENTS_LABELS[comment.status]
          })
        })
      }

      if (campaign.status_data) {
        // Get last comment status from central
        const lastComment = campaign.status_data.sort((a, b) => {
          return new Date(new Date(b.date).toISOString()) - new Date(new Date(a.date).toISOString())
        }).find(x => x.status === CAMPAIGN_STATUSES.CENTRAL_REJECTED || x.status === CAMPAIGN_STATUSES.CENTRAL_ACCEPTED)
        this.lastCentralCommentStatus = lastComment ? lastComment.status : undefined

        campaign.status_data.forEach(comment => {
          this.comments.push({
            status: comment.status,
            comment: comment.comment,
            date: new Date(new Date(comment.date).toISOString()),
            user: comment.user,
            title: CAMPAIGN_COMMENTS_LABELS[comment.status]
          })
        })
      }

      // order comments by date
      if (this.comments.length > 0) {
        this.comments.sort((a, b) => {
          return b.date - a.date
        })
      }

      this.campaign = { ...campaign, metadata: campaign.metadata || null }
      this.campaign.shops.forEach(s => {
        s.id = String(s.id)
      })
      this.campaign.start_date = new Date(this.campaign.start_date)
      this.campaign.finish_date = new Date(this.campaign.finish_date)
      this.loading = false
    },
    onChannelsChange () {
      this.getCampaign(this.campaignId)
    }
  },
  directives: {
    portal: Portal
  }
}
